var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBloctoMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 342 167",
    style: {
      enableBackground: "new 0 0 342 167"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;fill:#E0F0FF;enable-background:new    ;}\n\t.st1{fill:#FFFFFF;stroke:#0A94FF;stroke-width:1.79;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:none;stroke:#0A94FF;stroke-width:1.79;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#0A94FF;}\n\t.st4{fill:none;stroke:#0A94FF;stroke-width:1.79;stroke-miterlimit:10;}\n\t.st5{opacity:0.7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.3,123.8c75.3,0,136.3-7.7,136.3-17.2c0-9.5-61-17.2-136.3-17.2C61,89.3,0,97,0,106.5 C0,116,61,123.8,136.3,123.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.6,60.1H97v38.7c0,0.9-0.4,1.8-1,2.5c-0.7,0.7-1.6,1-2.5,1h-4.3c-0.9,0-1.8-0.4-2.5-1c-0.7-0.7-1-1.6-1-2.5 L85.6,60.1L85.6,60.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.1,142.5l5.4-7.7c0.2-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2l9.4,0.8c0.4,0,0.8,0.2,1.2,0.4 c0.4,0.2,0.6,0.6,0.8,1l5.7,15.5c0.2,0.4,0.2,0.8,0.2,1.2c0,0.4-0.2,0.8-0.4,1.2c-0.2,0.3-0.6,0.6-1,0.8c-0.4,0.2-0.8,0.3-1.2,0.2 l-16.5-0.1c-0.4,0-0.8-0.2-1.2-0.4c-0.4-0.2-0.6-0.6-0.8-1l-4-8.6c-0.2-0.4-0.3-0.8-0.2-1.2C99.7,143.3,99.9,142.9,100.1,142.5 L100.1,142.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.7,143.7l24.9,10.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.5,154.2l13.6-19.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.5,134l18.1,19.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.7,123.7l7.7-5.4c0.3-0.2,0.8-0.4,1.2-0.4c0.4,0,0.8,0,1.2,0.2l8.5,4c0.4,0.2,0.7,0.5,1,0.8 c0.2,0.4,0.4,0.8,0.4,1.2v16.5c0,0.4,0,0.8-0.2,1.2c-0.2,0.4-0.5,0.7-0.8,1s-0.8,0.4-1.2,0.4c-0.4,0-0.8,0-1.2-0.2l-15.5-5.8 c-0.4-0.2-0.7-0.5-1-0.8c-0.2-0.4-0.4-0.8-0.4-1.2l-0.8-9.4c0-0.4,0.1-0.8,0.2-1.2C138,124.2,138.3,123.9,138.7,123.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.9,124.6l19.8,18.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.7,136.2l19.4-13.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.6,117.9l10.1,24.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.9,22.4c5.5-0.9,9.3-6.1,8.4-11.6c-0.9-5.5-6.1-9.3-11.6-8.4c-5.5,0.9-9.3,6.1-8.4,11.6 C82.2,19.5,87.4,23.3,92.9,22.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.9,12.3c0-0.9-0.3-1.8-0.8-2.6C94.6,9,93.9,8.4,93,8.1c-0.8-0.3-1.8-0.4-2.7-0.3C89.5,8,88.7,8.5,88,9.1 c-0.6,0.6-1.1,1.5-1.3,2.4c-0.2,0.9-0.1,1.8,0.3,2.7c0.3,0.8,0.9,1.6,1.7,2.1c0.8,0.5,1.6,0.8,2.6,0.8c1.2,0,2.4-0.5,3.3-1.3 C95.4,14.7,95.9,13.6,95.9,12.3L95.9,12.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.7,60.1H187v38.7c0,0.9-0.4,1.8-1,2.5c-0.7,0.7-1.6,1-2.5,1h-4.3c-0.5,0-0.9-0.1-1.4-0.3 c-0.4-0.2-0.8-0.4-1.2-0.8c-0.3-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4L175.7,60.1L175.7,60.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.9,22.4c5.5-0.9,9.3-6.1,8.4-11.6c-0.9-5.5-6.1-9.3-11.6-8.4c-5.5,0.9-9.3,6.1-8.4,11.6 C172.2,19.5,177.4,23.3,182.9,22.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M185.9,12.3c0-0.9-0.3-1.8-0.8-2.6c-0.5-0.8-1.2-1.3-2.1-1.7c-0.8-0.3-1.8-0.4-2.7-0.3 c-0.9,0.2-1.7,0.6-2.4,1.3c-0.6,0.6-1.1,1.5-1.3,2.4c-0.2,0.9-0.1,1.8,0.3,2.7c0.3,0.8,0.9,1.6,1.7,2.1c0.8,0.5,1.6,0.8,2.6,0.8 c1.2,0,2.4-0.5,3.3-1.3C185.4,14.7,185.9,13.6,185.9,12.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.6,165.4c10,0,7-23.6,7-23.6c11.9,22.4,20.2,23.6,23.3,19.3c2-2.7,1.5-5.8-1.1-9.2 c-2.7-3.4-10.5-13.2-10.5-13.2c22,18.5,25.3,7,25.7,3.7c0.4-3.3-6.4-6.1-14.5-9.3c-8.7-3.4-6.2-7.4-6.2-7.4 c30.4-34.8,3.2-58.3-23.6-58.3s-54.1,23.5-23.6,58.3c0,0,2.5,4-6.2,7.4c-8.1,3.2-14.9,6-14.5,9.3c0.4,3.3,3.7,14.8,25.7-3.7 c0,0-7.9,9.7-10.5,13.2c-2.7,3.4-3.6,7.1-1.1,9.2c4.9,4.3,11.4,3.1,23.3-19.3C244.7,141.8,241.6,165.4,251.6,165.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.6,109.3c-2.2,0-3.7,2.5-3.7,6s1.5,6,3.7,6s3.7-2.5,3.7-6S253.8,109.3,251.6,109.3z M251.6,103.3 c5.4,0,9.7,5.4,9.7,12s-4.4,12-9.7,12c-5.4,0-9.7-5.4-9.7-12S246.2,103.2,251.6,103.3L251.6,103.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M233.7,95.6c-0.7,0-1.3,0.2-1.9,0.6c-0.6,0.4-1,0.9-1.3,1.5c-0.3,0.6-0.3,1.3-0.2,2c0.1,0.7,0.5,1.3,0.9,1.7 c0.5,0.5,1.1,0.8,1.7,0.9c0.7,0.1,1.3,0.1,2-0.2c0.6-0.3,1.2-0.7,1.5-1.3c0.4-0.6,0.6-1.2,0.6-1.9c0-0.4-0.1-0.9-0.2-1.3 c-0.2-0.4-0.4-0.8-0.7-1.1c-0.3-0.3-0.7-0.6-1.1-0.7C234.5,95.7,234.1,95.6,233.7,95.6L233.7,95.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M269.5,95.6c-0.7,0-1.3,0.2-1.9,0.6c-0.6,0.4-1,0.9-1.3,1.5c-0.3,0.6-0.3,1.3-0.2,2c0.1,0.7,0.5,1.3,0.9,1.7 c0.5,0.5,1.1,0.8,1.7,0.9c0.7,0.1,1.3,0.1,2-0.2c0.6-0.3,1.2-0.7,1.5-1.3c0.4-0.6,0.6-1.2,0.6-1.9c0-0.4-0.1-0.9-0.2-1.3 c-0.2-0.4-0.4-0.8-0.7-1.1c-0.3-0.3-0.7-0.6-1.1-0.7C270.4,95.7,270,95.6,269.5,95.6L269.5,95.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341,135.8c-7.4-46-44.1-50.3-44.1-50.3S324.2,101.2,341,135.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.4,106.7L323.4,106.7c-0.9-1.1-2.5-1.2-3.5-0.3l-36,31.5c-1,0.9-1.1,2.4-0.2,3.5l0,0c0.9,1,2.4,1.1,3.5,0.2 l36-31.6C324.2,109.2,324.3,107.7,323.4,106.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.5,100.9c1-0.8,1-2.3,0.2-3.2c-0.8-1-2.3-1-3.2-0.2l-5.5,4.8c-1,0.8-1,2.3-0.2,3.2c0.8,1,2.3,1,3.2,0.2 L333.5,100.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M331.7,103.6l-4.1-4.7c-0.6-0.7-1.8-0.8-2.5-0.2l-7.8,6.8c-0.7,0.6-0.8,1.8-0.2,2.5l4.1,4.7 c0.6,0.7,1.8,0.8,2.5,0.2l7.8-6.8C332.3,105.4,332.3,104.3,331.7,103.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.4,24.2L70.1,60.1H56.5l1.9-5l13.2-30.9H85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.8,24.2L87.5,60.1h13.8l15.3-35.9H102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.8,24.2l-15.3,35.9h-13.8L134,24.2H147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179,24.2l-15.3,35.9h-13.8l15.3-35.9H179z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.4,24.2l-15.3,35.9h13.8l15.2-35.6L196.4,24.2z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.4,24.2L70.1,60.1H56.4l1.9-5l13.2-30.9H85.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.7,24.2L87.4,60.1h13.9l15.3-35.9H102.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M147.8,24.2l-15.3,35.9h-13.8l15.3-35.9H147.8z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M179,24.2l-15.3,35.9h-13.8l15.3-35.9H179z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M196.3,24.2L181,60.1h13.8l15.2-35.6L196.3,24.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M216.3,24.2H56.2c-1.4,0-2.6,1.2-2.6,2.6v30.7c0,1.4,1.2,2.6,2.6,2.6h160.1c1.4,0,2.6-1.2,2.6-2.6V26.8 C218.9,25.4,217.8,24.2,216.3,24.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloctoMaintenance);
export default __webpack_public_path__ + "static/media/blocto_maintenance.f5717021820cdab45396bc61117c6ac0.svg";
export { ForwardRef as ReactComponent };